import React from "react";
import {
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import CustomNumberFormat from '@icarius-common/dynamicInputs/customNumberFormat';
import StepContainer from "./stepContainer";
import { getLocalizedString } from "@icarius-localization/strings";

const gridStyle = { height: 75, padding: "0px 10px" };

const StepThree = (props) => {

  const {
    selectedPerformanceScore,
    selectedPotentialScore,
    reviewsPotential,
    formData,
    setFormValue,
  } = props;

  const fieldsData = [
    {
      title: getLocalizedString("forFinalResultOfPerformanceEvaluation"),
      subtitle: getLocalizedString("xAxisFor9Boxes"),
      footer: getLocalizedString("possibleFinalScoresPerformance", { min: selectedPerformanceScore?.min || 0, max: selectedPerformanceScore?.max || 0 }),
      fields: [
        {
          title: getLocalizedString("onePoorPerformance"),
          fieldFrom: 'performanceFrom1',
          fieldTo: 'performanceTo1',
        },
        {
          title: getLocalizedString("performanceGood2"),
          fieldFrom: 'performanceFrom2',
          fieldTo: 'performanceTo2',
        },
        {
          title: getLocalizedString("outstandingPerformance3"),
          fieldFrom: 'performanceFrom3',
          fieldTo: 'performanceTo3',
        },
      ]
    },
    {
      title: getLocalizedString("forFinalResultOfPotentialEvaluation"),
      subtitle: getLocalizedString("yAxisFor9Boxes"),
      footer: getLocalizedString("possibleFinalScoresPerformance", { min: selectedPotentialScore?.min || 0, max: selectedPotentialScore?.max || 0 }),
      fields: [
        {
          title: getLocalizedString("oneLimitedPotential"),
          fieldFrom: 'potentialFrom1',
          fieldTo: 'potentialTo1',
        },
        {
          title: getLocalizedString("twoMediumPotential"),
          fieldFrom: 'potentialFrom2',
          fieldTo: 'potentialTo2',
        },
        {
          title: getLocalizedString("highPotential3"),
          fieldFrom: 'potentialFrom3',
          fieldTo: 'potentialTo3',
        },
      ]
    }
  ];

  return (
    <StepContainer title={getLocalizedString("finalGradeRangesFor9boxes")}>
      <Grid container item alignItems="flex-start" xs={12}>
        {
          fieldsData.map((section, sectionIndex) => {
            if (sectionIndex === 1 && !reviewsPotential) return null;

            return (
              <Grid container item alignItems="center" xs={12} sm={reviewsPotential ? 6 : 12} style={{ padding: "0px 10px" }} key={sectionIndex}>
                <Grid container item direction="column" justify="center" xs={12} style={{ ...gridStyle, padding: 0 }}>
                  <Typography className="whiteText" style={{ fontWeight: 600 }}>{section.title}</Typography>
                  <Typography className="whiteText">{section.subtitle}</Typography>
                </Grid>
                {
                  section.fields.map((item, index) => {
                    return (
                      <Grid
                        key={index}
                        container item alignItems="center" xs={12}
                        style={{ marginTop: 10, marginBottom: 10, padding: '10px 15px', background: 'var(--secondaryBackgroundColor)', borderRadius: 4 }}
                        className='myDesktopShadow'
                      >
                        <Grid container item alignItems="center" sm={12} md={6}>
                          <Typography className="whiteText">{item.title}</Typography>
                        </Grid>
                        <Grid container item alignItems="center" sm={12} md={6}>
                          <Grid container item alignItems="center" xs={6} style={{ paddingRight: 10 }}>
                            <TextField
                              required
                              label={getLocalizedString("pollFrom")}
                              value={formData[item.fieldFrom]}
                              fullWidth
                              margin={"none"}
                              onChange={(e) => setFormValue(e.target.value, item.fieldFrom)}
                              InputProps={{ inputComponent: CustomNumberFormat }}
                              inputProps={{ min: "0", step: "0.01", decimals: 2 }}
                            />
                          </Grid>
                          <Grid container item alignItems="center" xs={6}>
                            <TextField
                              required
                              label={getLocalizedString("pollTo")}
                              value={formData[item.fieldTo]}
                              fullWidth
                              margin={"none"}
                              onChange={(e) => setFormValue(e.target.value, item.fieldTo)}
                              InputProps={{ inputComponent: CustomNumberFormat }}
                              inputProps={{ min: "0", step: "0.01", decimals: 2 }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    )
                  })
                }
                <Typography className="whiteText">{section.footer}</Typography>
              </Grid>
            )
          })
        }
      </Grid>
    </StepContainer>
  );
}

export default StepThree;